module.exports = __webpack_public_path__ + "static/media/googleaa7a8b2d6a176fd2.e8bcd066.txt";